import React from 'react';
import moment from 'moment';
import { momentDurationToTime } from '../reporting/reporting_utils/misc';
import { Common } from '../utils/common';
import CallProcessingPlayer from './CallProcessingPlayer';
import { useRescoreData } from './api';
import RescoreForm from './RescoreForm';

/**
 * @param {{ callId: string; onSaveSuccess?: () => void; }} props
 */
export default function CallProcessor({ callId, onSaveSuccess }) {
  const rescoreDataQuery = useRescoreData(callId);

  if (rescoreDataQuery.isLoading) {
    return <p>Loading...</p>;
  }

  if (rescoreDataQuery.isError) {
    return (
      <p>
        {rescoreDataQuery.error instanceof Error
          ? rescoreDataQuery.error.message
          : 'Failed to fetch rescore data'}
      </p>
    );
  }

  if (rescoreDataQuery.data.call_types.length === 0 || !rescoreDataQuery.data.scoring_settings) {
    return <p>Rescoring is not available for this call</p>;
  }

  return (
    <>
      <div className='well'>
        <CallProcessingPlayer url={rescoreDataQuery.data.scoring_settings.audiourl} />
      </div>

      {rescoreDataQuery.data.scoring_settings ? (
        <div className='panel panel-default'>
          <table className='table'>
            <thead>
              <tr>
                <th className='centered'>Call Date</th>
                <th className='centered'>Start Time</th>
                <th className='centered'>Audio Duration</th>
                <th className='centered'>Location</th>
                <th className='centered'>Call ID</th>
                <th className='centered'>Called Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td id='call_start_date' className='centered'>
                  {moment(rescoreDataQuery.data.scoring_settings.call_start_time).format(
                    'MMM D, YYYY'
                  )}
                </td>
                <td id='call_start_time' className='centered'>
                  {moment(rescoreDataQuery.data.scoring_settings.call_start_time).format('h:mm A')}
                </td>
                <td id='call_duration' className='centered'>
                  {momentDurationToTime(
                    moment.duration(rescoreDataQuery.data.scoring_settings.duration, 'seconds')
                  )}
                </td>
                <td id='call_location' className='centered'>
                  {rescoreDataQuery.data.scoring_settings.location_name}
                </td>
                <td id='call_id' className='centered'>
                  {callId}
                </td>
                <td id='called_number' className='centered'>
                  {Common.formatPhoneNumber(rescoreDataQuery.data.scoring_settings.ani)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : null}
      <RescoreForm
        scoringSettings={rescoreDataQuery.data.scoring_settings}
        callTypes={rescoreDataQuery.data.call_types}
        onSaveSuccess={onSaveSuccess}
        callId={callId}
      />
    </>
  );
}
